"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function getDataAttributes(value, prefix) {
  if (prefix) return "".concat(prefix, "-").concat(value);
  return value;
}

var _default = getDataAttributes;
exports["default"] = _default;
//# sourceMappingURL=getDataAttributes.js.map